var _link, _style, _path, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfNewMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1800,
    height: 1200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1800v1200H0z",
    fill: "gold"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 27,
    stroke: "#bf0a30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956.5 353.395v493.21M918.818 313.5v573m-37.636-573v573M843.5 353.395v493.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.395 543.5h493.21M613.5 581.182h573m-573 37.636h573M653.395 656.5h493.21"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 600,
    r: 93.25,
    fill: "gold",
    strokeWidth: 13.5,
    stroke: "#bf0a30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfNewMexico);
export default __webpack_public_path__ + "static/media/Flag_of_New_Mexico.56969201bdc02733191263995d7c2354.svg";
export { ForwardRef as ReactComponent };